import { render } from "./BaseInfo.vue?vue&type=template&id=0bea65bf&scoped=true&ts=true"
import script from "./BaseInfo.vue?vue&type=script&lang=ts"
export * from "./BaseInfo.vue?vue&type=script&lang=ts"

import "./BaseInfo.vue?vue&type=style&index=0&id=0bea65bf&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bea65bf"]])

export default __exports__